"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interfaces = require("@fhx/interfaces");

var _skill = _interopRequireDefault(require("./skill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusEffect = {
  id: 3456345,
  byClassSkill: _skill.default,
  isNegative: false,
  isAboutToExpire: false,
  createdAt: new Date(),
  updatedAt: new Date()
};
var individual = {
  level: 42,
  mainAttributes: {
    vitality: 20,
    dexterity: 5,
    intelligence: 43,
    strength: 44
  },
  mainAttributeBonuses: {
    vitality: 0,
    dexterity: 0,
    intelligence: 0,
    strength: 0
  },
  offense: {
    physicalMin: 10,
    physicalMax: 10,
    magicalMin: 10,
    magicalMax: 10
  },
  defense: {
    physical: 10,
    magical: 10
  },
  resistance: {
    attack: 10,
    curse: 10,
    melee: 10,
    ranged: 10
  },
  energy: {
    hp: 500,
    hpMax: 1000,
    mp: 400,
    mpMax: 2000,
    sp: 10,
    spMax: 500
  },
  equipment: {
    id: 234234234,
    equipmentSlots: [],
    areSecondaryHandsActive: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: undefined
  },
  classSkills: [],
  statusEffects: [statusEffect, statusEffect, statusEffect, statusEffect, statusEffect, _objectSpread(_objectSpread({}, statusEffect), {}, {
    isAboutToExpire: true
  }), statusEffect, statusEffect, statusEffect, statusEffect, _objectSpread(_objectSpread({}, statusEffect), {}, {
    isNegative: true
  }), _objectSpread(_objectSpread({}, statusEffect), {}, {
    isNegative: true,
    isAboutToExpire: true
  }), _objectSpread(_objectSpread({}, statusEffect), {}, {
    isNegative: true
  })],
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  direction: {
    x: 0,
    y: 0,
    z: 0
  },
  gender: _interfaces.EGender.MALE,
  isInSittingStance: false,
  isInAttackStance: false,
  isInRunStance: true,
  movementSpeed: 42,
  target: undefined,
  createdAt: new Date(),
  updatedAt: new Date(),
  deletedAt: undefined
};

var character = _objectSpread(_objectSpread({}, individual), {}, {
  id: 42,
  name: "WizardOfTheHELL",
  isHardcore: false,
  rank: "Partial Lawful",
  reputation: 42,
  attributePoints: 20,
  skillPoints: 20,
  pictureFileName: "",
  avatarFileName: "mockCharAvatar.jpg",
  boundPosition: {
    x: 0,
    y: 0,
    z: 0
  },
  boundDirection: {
    x: 0,
    y: 0,
    z: 0
  },
  characterClass: {
    id: "wizard",
    isEnabled: true,
    i18nTag: {
      en: "Wz",
      de: "Za"
    },
    i18nName: {
      en: "Wizard",
      de: "Zauberer"
    },
    i18nDescription: {
      en: "",
      de: ""
    },
    classSkillModels: [],
    classSkillModelsV2: [],
    classSkillComboModels: [],
    classSkillComboModelsV2: [],
    attributeMultipliers: {
      dexterityAccuracy: 0,
      dexterityEvasionMagic: 0,
      dexterityEvasionMelee: 0,
      dexterityMovementSpeed: 0,
      dexterityPhyAttack: 0,
      intelligenceMagAttack: 0,
      intelligenceMagDef: 0,
      intelligenceMana: 0,
      intelligenceResistCurse: 0,
      strenghtPhyAttack: 0,
      strenghtPhyDef: 0,
      strenghtResistAttack: 0,
      strenghtResistMelee: 0,
      strenghtResistRanged: 0,
      vitalityHitpoints: 0,
      vitalityStamina: 0
    }
  },
  characterRace: {
    id: "highelf",
    isEnabled: true,
    i18nTag: {
      en: "He",
      de: "He"
    },
    i18nName: {
      en: "Hichelf",
      de: "Hockelf"
    },
    i18nDescription: {
      en: "",
      de: ""
    },
    mainAttributesBases: {
      dexterity: 0,
      intelligence: 0,
      strength: 0,
      vitality: 0
    },
    allowsCharacterClasses: []
  },
  inventory: {
    money: {
      cp: 234234,
      gp: 2345,
      pp: 346464363
    },
    itemPool: {
      sizeX: 12,
      sizeY: 10,
      items: []
    }
  },
  groups: [],
  friends: [],
  party: null,
  guild: {
    name: "Mocked Guild"
  },
  nation: {
    id: "mockNation",
    characters: [],
    guilds: [],
    i18nName: {
      en: "Mock Nation",
      de: "Mock Nation"
    }
  },
  guildmasterOf: null,
  partyLeaderOf: null,
  mercenary: null,
  pet: null,
  shop: null,
  quests: [],
  experience: 8000,
  experienceMax: 10000
});

var _default = character;
exports.default = _default;